<template>
  <div class="callback-container">
    <div class="loading-spinner"></div>
    <p class="loading-text">게임을 불러오는 중...</p>
  </div>
</template>

<script>
export default {
  name: "SlotCallback",
  data() {
    return {
      loading: true,
      error: null
    };
  },
  computed: {
    isMobile() {
      const queryMobile = this.$route.query.isMobile;
      if (queryMobile !== undefined) {
        return queryMobile === 'true' || queryMobile === '1';
      }
      return this.$store.state.page.isMobile;
    }
  },
  async mounted() {
    await this.launchGame();
  },
  methods: {
    async launchGame() {
      const { product_id, type } = this.$route.params;

      if (!this.$store.state.user?.user) {
        this.$store.dispatch('SHOW_ERR_MSG', '로그인이 필요합니다.');
        this.$router.push('/login');
        return;
      }

      try {
        const params = {
          domain_url: window.location.protocol + "//" + window.location.host,
          product_id: parseInt(product_id),
          type: parseInt(type) || 0,
          is_mobile: this.isMobile ? 1 : 0
        };

        const response = await this.$store.dispatch('GET_KPLAY_GAME', params);

        if (response.data && response.data.url) {
          // 현재 창에서 게임 URL로 리다이렉트
          window.location.href = response.data.url;
        } else {
          this.$store.dispatch('SHOW_ERR_MSG', '게임을 불러올 수 없습니다.');
          this.$router.push('/casino/kplay/slot');
        }
      } catch (error) {
        console.error('Game launch error:', error);
        this.$store.dispatch('SHOW_ERR_MSG', '게임 실행 중 오류가 발생했습니다.');
        this.$router.push('/casino/kplay/slot');
      }
    }
  }
};
</script>

<style scoped>
.callback-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #1a1f1f;
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid #3a4040;
  border-top: 4px solid #D4AF37;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-text {
  margin-top: 20px;
  color: #D4AF37;
  font-size: 16px;
}
</style>
